import script from "./End.vue?vue&type=script&setup=true&lang=js"
export * from "./End.vue?vue&type=script&setup=true&lang=js"

import "./End.vue?vue&type=style&index=0&id=07e70c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e70c86"]])

export default __exports__